import { computed, type ComputedRef, type Ref } from 'vue'
import { useRoute } from 'vue-router'
import type { ImpactArea } from '../impact-of-disability_types'

type NonAIEventContextSources = {
  isNonAIMode: ComputedRef<boolean>
  disability: Ref<string>
  disabilityLabel: ComputedRef<string>
  subjects: Ref<string[]>
  impactAreas: ComputedRef<ImpactArea[]>
}

// In AI mode each field is undefined, which the event POST drops, so AI events' payloads are unchanged.
export function useNonAIEventContext({ isNonAIMode, disability, disabilityLabel, subjects, impactAreas }: NonAIEventContextSources) {
  const route = useRoute()

  const onlyInNonAIMode = <T>(value: () => T) => computed(() => (isNonAIMode.value ? value() : undefined))

  return {
    ref: onlyInNonAIMode(() => route.query.ref),
    iod_selected_disability: onlyInNonAIMode(() => disabilityLabel.value),
    iod_selected_subjects: onlyInNonAIMode(() => subjects.value),
    iod_selected_impact_areas: onlyInNonAIMode(() => impactAreas.value.map(impactArea => impactArea.area_label)),
    iod_page: onlyInNonAIMode(() => (disability.value ? 'Results' : 'Wizard'))
  }
}
